import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import { FormattedMessage } from 'react-intl';
var acceptanceInfo = {
  accept: {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "rIbqjm",
      description: "Accepting",
      defaultMessage: "Accepting referrals"
    }),
    icon: /*#__PURE__*/React.createElement(Icon, {
      icon: "IconCheckCircle",
      color: "#4ECE3D",
      className: "mr-quarter"
    })
  },
  deny: {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "l8K7Nm",
      description: "not-accepting",
      defaultMessage: "Not accepting referrals"
    }),
    icon: /*#__PURE__*/React.createElement(Icon, {
      icon: "IconTimesCircle",
      color: "#CF2A2A",
      className: "mr-quarter"
    })
  }
};
function ProgramAcceptance(props) {
  var receiving_referrals = props.receiving_referrals,
    status = props.status;
  return /*#__PURE__*/React.createElement("div", {
    className: "program-acceptance mt-half"
  }, receiving_referrals ? acceptanceInfo.accept.icon : acceptanceInfo.deny.icon, receiving_referrals ? /*#__PURE__*/React.createElement("p", null, acceptanceInfo.accept.text) : /*#__PURE__*/React.createElement("p", null, acceptanceInfo.deny.text, " ", status && "(".concat(status, ")")));
}
ProgramAcceptance.propTypes = {
  receiving_referrals: PropTypes.bool.isRequired,
  status: PropTypes.string
};
ProgramAcceptance.defaultProps = {
  status: '',
  hide_referrals: false,
  is_active: false
};
export default ProgramAcceptance;